/**
 * StatefulCollection
 * This collections implements interface to to page, filter, and sort the data.
 * Primary use is SmartTable component.
 */
import { _ } from "extensions/underscore";
import { StatefulCollection } from "common/collections/statefulCollection";

export const ActionableCollection = StatefulCollection.extend({
    constructor: function constructor(options) {
        StatefulCollection.apply(this, arguments);
    },

    resetStateAndParams() {
        this.resetState();
        this.resetParams();
    },

    setLimit(limit) {
        return this._setQueryParamsAndFetch({
            limit,
            page: 1 // Need to reset to page one here
        });
    },

    getPage(page) {
        return this._setQueryParamsAndFetch({
            page
        });
    },

    filterBy(where) {
        if (!_.isObject(where)) {
            throw new TypeError("Expected object structure for the filter call");
        }

        return this._setQueryParamsAndFetch(where, true);
    },

    apiSort(sortObject) {
        if (_.isObject(sortObject) && !_.isFunction(sortObject)) {
            this._setQueryParamsAndFetch(sortObject, true);
        }
    }
});
